module.exports = __webpack_public_path__ + "img/01.32fcf6e8.jpg";